import React, { useState, useEffect } from "react";

import useEventManager from "hooks/useEventManager";

import styles from "./mainLoader.scss";

const { main_loader, main_loader_hide, loading_bar } = styles;

const MainLoader = () => {

    const [state, setState] = useState({ show: false });
    const { _subscribe, _unsubscribe, events, EVENT_NAMES } = useEventManager();

    useEffect(() => {
        if (events && !events[EVENT_NAMES.LOADER]) {
            addLoaderListener();
        }
    }, [events]);

    useEffect(() => {
        return () => removeLoaderListener();
    }, []);

    const addLoaderListener = () => {
        _subscribe(EVENT_NAMES.LOADER, ({ show }) => setState({ show }));
    };

    const removeLoaderListener = () => {
        _unsubscribe(EVENT_NAMES.LOADER, ({ show }) => setState({ show }));
    };

    return (
        <div className={`${main_loader} ${state.show ? "" : main_loader_hide}`}>
            <div className={loading_bar}></div>
        </div>
    );
}

export default MainLoader;